import clsx from 'clsx';
import { ComponentPropsWithoutRef, FC } from 'react';
import { Icon } from '../Icon';
import { buttonFocusRingClasses } from './util';

export interface ButtonProps
  extends Pick<
    ComponentPropsWithoutRef<'button'>,
    'disabled' | 'className' | 'onClick' | 'type' | 'style' | 'name' | 'value'
  > {
  icon?: JSX.Element;
  themeType?: 'primary' | 'link' | 'shade' | 'danger' | 'shade-hover';
  contentHeight?: number;
  loading?: boolean;
  customDisabledClassName?: string;
  size?: 'small' | 'default';
  iconPosition?: 'left' | 'right';
  children?: React.ReactNode;
}

/**
 * 
 * @deprecated Use ElementsButton instead
 */
export const Button: FC<ButtonProps> = ({
  children,
  icon,
  themeType = 'primary',
  contentHeight = 37,
  loading,
  disabled,
  className,
  size = 'default',
  customDisabledClassName,
  iconPosition = 'left',
  onClick,
  ...generalButtonProps
}) => {
  let themeStyles = [
    'bg-palette-600 px-8',
    'text-darkMode-gray-dark',
    !disabled && !loading && 'active:bg-palette-600/80',
  ];
  if (themeType === 'link') {
    themeStyles = [
      'bg-transparent text-palette-600 px-0 py-[18px] rounded-none active:opacity-60 hover:text-palette-600/80',
    ];
  } else if (themeType === 'shade') {
    themeStyles = [
      'bg-palette-600/20 text-palette-600 px-8',
      !disabled && !loading && 'active:opacity-70',
    ];
  } else if (themeType === 'shade-hover') {
    themeStyles = [
      'hover:bg-palette-600/20 text-palette-600 px-8',
      !disabled && !loading && 'active:opacity-70',
    ];
  } else if (themeType === 'danger') {
    themeStyles = [
      '!bg-darkMode-danger text-darkMode-gray-dark px-8',
      !disabled && !loading && 'active:opacity-60 ',
    ];
  }
  let sizeStyles = '';
  if (size === 'small') {
    sizeStyles = '!text-[15px] !h-10 !py-0 !px-[19px] sticky bottom-6 block';
  }

  return (
    <button
      {...generalButtonProps}
      disabled={loading || disabled}
      onClick={!loading && !disabled ? onClick : () => {}}
      className={clsx(
        'rounded-full py-3 text-xl font-bold leading-6',
        buttonFocusRingClasses(themeType === 'danger' ? 'danger' : 'primary'),
        (disabled || loading) &&
          'cursor-not-allowed !select-none !bg-darkMode-gray-medium/40 !text-darkMode-gray-dark',
        themeStyles,
        className,
        sizeStyles,
        (disabled || loading) && customDisabledClassName
      )}
    >
      <div
        style={{ height: `${contentHeight}px` }}
        className="grid grid-flow-col items-center justify-center gap-2"
      >
        {loading ? (
          <Icon icon="spinner" />
        ) : (
          <>
            {icon}
            {children && (
              <span
                className={clsx(
                  'mt-[2px]',
                  iconPosition === 'right' && 'order-[-1]'
                )}
              >
                {children}
              </span>
            )}
          </>
        )}
      </div>
    </button>
  );
};

export default Button;
